export function normalizeDdtSearch(value) {
    if (typeof value !== 'string') return '';
    const term = value.trim().toUpperCase();
    return /^(?:DDT)?[0-9]{3,17}$/.test(term) && term.length <= 20 ? term : '';
}

export function ddtHit(item) {
    const date = item.data ? new Date(`${item.data.slice(0, 10)}T00:00:00`).toLocaleDateString('it-IT') : '';
    return { codice: item.numero, descrizione: `${item.ragione_sociale} · ${date}`, route: 'DdtDettaglio', searchType: 'ddt' };
}

export default {
    data: () => ({ ddtHits: [], ddtSearchTerm: '', ddtSearchLoading: false, ddtSearchError: '', ddtHasMore: false, ddtSearchSequence: 0, ddtSearchTimer: null }),
    computed: {
        canSearchDdt() { return this.$store.getters.hasGroups(['Amministrazione', 'Magazzino', 'Schedulazione']); },
    },
    beforeDestroy() { clearTimeout(this.ddtSearchTimer); this.ddtSearchSequence++; },
    methods: {
        scheduleDdtSearch(value) {
            clearTimeout(this.ddtSearchTimer);
            const sequence = ++this.ddtSearchSequence;
            this.ddtHits = []; this.ddtSearchError = ''; this.ddtHasMore = false;
            const term = this.canSearchDdt ? normalizeDdtSearch(value) : '';
            this.ddtSearchTerm = term;
            this.ddtSearchLoading = Boolean(term);
            if (term) this.ddtSearchTimer = setTimeout(() => this.loadDdtSearch(term, sequence), 250);
        },
        async loadDdtSearch(term, sequence) {
            try {
                const response = await this.$work.get('/ordini/ddt-ricerca/', { q: term }, false, null, { ignoreGlobalErrorStatuses: [400, 403, 503] });
                if (!Array.isArray(response?.data?.items)) throw new Error('Risposta non valida');
                if (sequence === this.ddtSearchSequence) {
                    this.ddtHits = response.data.items.map(ddtHit);
                    this.ddtHasMore = Boolean(response.data.has_more);
                }
            } catch (_) {
                if (sequence === this.ddtSearchSequence) this.ddtSearchError = 'Ricerca DDT non disponibile. Riprova.';
            } finally { if (sequence === this.ddtSearchSequence) this.ddtSearchLoading = false; }
        },
    },
};
